import { createFileRoute } from "@tanstack/react-router";
import { Privacy } from "../../pages/Privacy/Privacy";

export const Route = createFileRoute("/_public/privacy")({
  component: Privacy,
});
